import Vue from 'vue'
import router from '@/router'
import store from '@/store'
import { i18n } from '@/i18n'
import VueApexCharts from 'vue-apexcharts'

// Lib imports
import axios from 'axios'
import { cacheAdapterEnhancer } from 'axios-extensions'

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

// enhance the original axios adapter with throttle and cache enhancer
const http = axios.create({
  baseURL: '/',
  headers: { 'Cache-Control': 'no-cache' },
  timeout: 5 * 60 * 1000,
  // disable the default cache
  adapter: cacheAdapterEnhancer(axios.defaults.adapter, { enabledByDefault: false })
})

// console.log('http.defaults.timeout=' + http.defaults.timeout)
// http.defaults.timeout = 60 * 1000
http.interceptors.response.use((response) => {
  // console.log(response)
  return response
}, function (error) {
  if (error.response.status === 401) {
    if (!error.response.config.url.endsWith('/login')) {
      store
        .dispatch('logout')
        .then(() => router.push('/landingpage'))
    }
    return
  }

  return Promise.reject(error)
})

Vue.prototype.$http = http

// api url
const isProd = process.env.NODE_ENV === 'production'
const API_URL = isProd ? '' : 'http://localhost:3000' // FOR DEPLOY
// const API_URL = isProd ? '' : 'http://10.90.10.92:3000' // local
// const API_URL = isProd ? '' : 'http://95.226.75.5:3000' // vescovato
// const API_URL = isProd ? '' : 'http://46.7.34.137:3000' // fergus
// const API_URL = isProd ? '' : 'http://37.148.231.226:3092'
// const API_URL = isProd ? '' : 'http://192.168.20.156:3000' // Italy Lab

// useful methods
Vue.prototype.Maglink = Vue.prototype.Maglink || {}

Vue.prototype.Maglink.isResponsive = false

Vue.prototype.Maglink.isPlus = false

Vue.prototype.Maglink.hasCsld = false

Vue.prototype.Maglink.userList = []

// manage superadmin permissions
Vue.prototype.Maglink.LoggedUser = { username: 'Guest', id: 2, role: 1, isGuest: true, isTechnician: false, isAdmin: false, isSuperAdmin: false }
Vue.prototype.Maglink.SetLoggedUser = (user) => {
  if (user) {
    let isTech = false
    if (user.role === 2) isTech = true
    let isAdm = false
    if (user.role === 3) isAdm = true
    let isSuperAdm = false
    if (user.role === 4) isSuperAdm = true

    Vue.prototype.Maglink.LoggedUser = {
      isTechnician: isTech,
      isAdmin: isAdm,
      isSuperAdmin: isSuperAdm,
      isGuest: !(isTech || isAdm || isSuperAdm),
      role: user.role,
      id: user.id,
      username: user.username
    }
  }
}
Vue.prototype.Maglink.CheckPermission = () => {
  if (Vue.prototype.Maglink.LoggedUser.isGuest) router.push('/landingpage')
}

Vue.prototype.Maglink.IsTechnicianUser = () => {
  return Vue.prototype.Maglink.LoggedUser.isTechnician
}
Vue.prototype.Maglink.IsAdminUser = () => {
  return (Vue.prototype.Maglink.LoggedUser.isAdmin || Vue.prototype.Maglink.LoggedUser.isSuperAdmin)
}
Vue.prototype.Maglink.IsSuperAdminUser = () => {
  return Vue.prototype.Maglink.LoggedUser.isSuperAdmin
}
Vue.prototype.Maglink.IsGuestUser = () => {
  return Vue.prototype.Maglink.LoggedUser.isGuest
}

Vue.prototype.Maglink.PasswordChangableUserList = () => {
  let UserList = []
  if (Vue.prototype.Maglink.IsTechnicianUser()) {
    Vue.prototype.Maglink.userList.forEach((usr) => {
      if (usr.role === 2) { // technician can change password for: Technician
        let u = { id: usr.id, name: i18n.t(usr.username) }
        UserList.push(u)
      }
    })
    return UserList
  }
  if (Vue.prototype.Maglink.IsAdminUser()) {
    Vue.prototype.Maglink.userList.forEach((usr) => {
      if (usr.role === 1 || usr.role === 2 || usr.role === 3) { // Admin can change password for: Guest, Technician, Admin
        let u = { id: usr.id, name: i18n.t(usr.username) }
        UserList.push(u)
      }
    })
    return UserList
  }
  if (Vue.prototype.Maglink.IsSuperAdminUser()) {
    Vue.prototype.Maglink.userList.forEach((usr) => {
      if (usr.role === 1 || usr.role === 2 || usr.role === 3) { // SuperAdmin can change password for: Guest, Technician, Admin
        let u = { id: usr.id, name: i18n.t(usr.username) }
        UserList.push(u)
      }
    })
    return UserList
  }
  return UserList
}

// lets try to start with an already stored user
const userString = localStorage.getItem('user')
if (userString) {
  const user = JSON.parse(userString)
  Vue.prototype.Maglink.SetLoggedUser(user)
  Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + user.token
}

Vue.prototype.Maglink.PadRight = (value, num, char = '0') => {
  let leeadingChars = char.repeat(num)
  return (leeadingChars + value).slice(-num)
}
Vue.prototype.Maglink.RulesRequired = (v) => {
  return (!!v || v === 0) || i18n.t('Required')
}
Vue.prototype.Maglink.RulesRequiredPositive = (v) => {
  return (!!v && Number.isInteger(v) && v > 0) || i18n.t('Required')
}
Vue.prototype.Maglink.RulesRange = (v, minValue, maxValue) => {
  return (v >= minValue && v <= maxValue) || i18n.t('Accepted values: {0} - {1}', [ minValue, maxValue ])
}
Vue.prototype.Maglink.RulesDoubleRange = (v, min1Value, max1Value, min2Value, max2Value) => {
  return ((v >= min1Value && v <= max1Value) || (v >= min2Value && v <= max2Value)) || i18n.t('Accepted values: ({0})-({1}) ({2})-({3})', [ min1Value, max1Value, min2Value, max2Value ])
}
Vue.prototype.Maglink.RulesFixedLen = (v, value) => {
  return (!v) || (v && v.length === value) || i18n.t('Must be {0} chars long', [value])
}
Vue.prototype.Maglink.RulesMaxLen = (v, value) => {
  return (!v) || (v && v.length <= value) || i18n.t('Max length: {0}', [value])
}
Vue.prototype.Maglink.RulesEmail = (v) => {
  return (!v) || (!!v && !!v.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) || i18n.t('Invalid email address')
}
Vue.prototype.Maglink.RulesIP = (v) => {
  return (!v) || (!!v && !!v.match(/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/)) || i18n.t('Invalid IP address')
}
Vue.prototype.Maglink.RulesMinutes = (v) => {
  return (!v) || (!!v && !!v.match(/^([0-9]|[1-9][0-9]|[1-9][0-9][0-9])(:[0-5][0-9])?$/)) || i18n.t('Invalid value')
}

// from 0..12
Vue.prototype.Maglink.TankColor = [
  'blue',
  'black',
  'yellow',
  'yellow',
  'yellow',
  'yellow',
  'yellow',
  'orange',
  'orange',
  'black',
  'green',
  'green',
  'green',
  'green',
  'green',
  'green',
  'green',
  'yellow',
  'black',
  'blue',
  'blue',
  'black'
]

// DMP send/response general commands
Vue.prototype.Maglink.GetProbeResponse = (serial, token) => { return http.get(API_URL + '/api/v1/special_command?serial=' + serial + '&token=' + token) }
Vue.prototype.Maglink.SendProbeCommand = (serial, cmd) => { return http.post(API_URL + '/api/v1/special_command?serial=' + serial, { command: cmd }) }
Vue.prototype.Maglink.GetToken = (probeSerial, tankNumber, cmdType, cmdText) => {
  return {
    command: {
      serial: probeSerial,
      tank: tankNumber,
      type: cmdType,
      text: cmdText
    },
    response: {
      id: '',
      text: '',
      status: false, // false = waiting response; true = completed;
      errorCode: 0,
      errorMsg: '',
      regExpression: '',
      values: {}
    },
    failCounter: 0,
    retry: 0
  }
}
Vue.prototype.Maglink.DecodeProbeResponse = (token) => {
  if (token.response.text === '') {
    token.response.errorCode = 1001
    token.response.errorMsg = i18n.t('Command "{0}" has empty response', [ token.command.type ])

    return token
  }

  if (token.command.type === 'V') return Vue.prototype.Maglink.DecodeProbe_Version(token)
  if (token.command.type === 'S') return Vue.prototype.Maglink.DecodeProbe_DensityValue(token, 'r')
  if (token.command.type === 'W') return Vue.prototype.Maglink.DecodeProbe_Density(token, 'w')
  if (token.command.type === 'J') return Vue.prototype.Maglink.DecodeProbe_DensityCoeff(token, 'r')
  if (token.command.type === 'Y') return Vue.prototype.Maglink.DecodeProbe_DensityCoeff(token, 'w')
  if (token.command.type === 'i') return Vue.prototype.Maglink.DecodeProbe_Pulse(token)
}
Vue.prototype.Maglink.ExtractResponse = (token) => {
  let reResult = token.response.regExpression.exec(token.response.text)

  if (reResult === undefined || reResult === null || reResult.groups === null) {
    token.response.errorCode = 1001
    token.response.errorMsg = i18n.t('Command "{0}": wrong format "{1}"', [ token.command.type, token.response.text ])
    token.response.values = undefined
  } else {
    token.response.values = reResult.groups
  }
}
Vue.prototype.Maglink.DecodeProbe_Pulse = (token) => {
  let items = token.response.text.split(';')
  let data = []
  for (var i = 1; i < items.length - 1; i = i + 3) {
    data.push({ seq: 0, rise: items[i], fall: items[i + 1], delta: items[i + 2] })
  }
  token.response.values.data = data
  return token
}
Vue.prototype.Maglink.DecodeProbe_Version = (token) => {
  // handle known differences
  if (token.response.text.indexOf('=') < 0) token.response.text += '=' + token.command.serial

  // version format could be tricky
  // token.response.regExpression = /^(?<firmware>.{5})=(?<serial>.{5})/
  // Vue.prototype.Maglink.ExtractResponse(token)

  let values = { firmware: '', serial: '' }
  let items = token.response.text.split('=')
  values.firmware = items[0]
  values.serial = items[1]
  token.response.values = values

  return token
}
Vue.prototype.Maglink.DecodeProbe_DensityCoeff = (token, rw) => {
  if (rw === 'r') {
    token.response.regExpression = /^(?<address>.{5})=(?<coeffA>.{10})=(?<coeffB>.{10})=(?<fuelType>.{1})/
  } else {
    token.response.regExpression = /^(?<address>.{5})=(?<coeffA>.{9})=(?<coeffB>.{9})/

    Vue.prototype.Maglink.ExtractResponse(token)

    // in version DMP04: format is as prev command but it's not compliant but in production
    // in future should be this format, maybe i will handle checking dmp version
    if (token.response.errorCode !== 0) {
      token.response.regExpression = /^(?<address>.{5})=(?<coeffA>.{10})=(?<coeffB>.{10})/
      Vue.prototype.Maglink.ExtractResponse(token)
    }
  }

  Vue.prototype.Maglink.ExtractResponse(token)

  if (token.response.errorCode === 0) {
    token.response.values.coeffA = token.response.values.coeffA * 1
    token.response.values.coeffB = token.response.values.coeffB * 1
    if (rw === 'r') token.response.values.fuelType = token.response.values.fuelType * 1
  }

  return token
}
Vue.prototype.Maglink.DecodeProbe_Density = (token, rw) => {
  if (rw === 'w') {
    token.response.regExpression = /^(?<address>.{5})=(?<fuelType>.{1})=(?<isCompensated>.{1})=(?<density>.{5})/
    Vue.prototype.Maglink.ExtractResponse(token)

    if (token.response.errorCode === 0) {
      token.response.values.isCompensated = token.response.values.isCompensated * 1
      token.response.values.density = token.response.values.density * 1
      token.response.values.fuelType = token.response.values.fuelType * 1
    }
  }
  return token
}
Vue.prototype.Maglink.DecodeProbe_DensityValue = (token, rw) => {
  if (rw === 'r') {
    token.response.regExpression = /^(?<address>.{5})=(?<error>.{1})=(?<grossDensity>.{7})=(?<netDensity>.{7})=(?<position>.{5})/
    Vue.prototype.Maglink.ExtractResponse(token)

    if (token.response.errorCode === 0) {
      token.response.values.isCompensated = token.response.values.isCompensated * 1
      token.response.values.grossDensity = token.response.values.grossDensity * 1
      token.response.values.netDensity = token.response.values.netDensity * 1
      token.response.values.position = token.response.values.position * 1
      token.response.values.error = token.response.values.error * 1
    }
  }
  return token
}

Vue.prototype.Maglink.GetVersion = () => { return http.get(API_URL + '/software_version') }
Vue.prototype.Maglink.GetOfflineStatus = () => { return http.get(API_URL + '/api/v1/offline_status') }

// settings
Vue.prototype.Maglink.GetSettings = (group) => { return http.get(API_URL + '/api/v1/settings/' + group) }
Vue.prototype.Maglink.SetSettings = (group, payload) => { return http.post(API_URL + '/api/v1/settings/' + group, payload) }
Vue.prototype.Maglink.IsApplyNeeded = () => { return http.get(API_URL + '/api/v1/settings/apply_needed') }
Vue.prototype.Maglink.ApplySettings = () => { return http.post(API_URL + '/api/v1/apply_settings') }
Vue.prototype.Maglink.GetDiagnosticPushData = () => { return http.get(API_URL + '/api/v1/diagnostic/push_data') }

// site mapping
Vue.prototype.Maglink.GetSiteMapping = () => { return http.get(API_URL + '/api/v1/site_mapping') }
Vue.prototype.Maglink.SaveSiteMapping = (item) => { return http.post(API_URL + '/api/v1/save_site_mapping', item) }

// sensors
Vue.prototype.Maglink.GetSensors = () => { return http.get(API_URL + '/api/v1/sensors') }
Vue.prototype.Maglink.GetSensorsList = () => { return http.get(API_URL + '/api/v1/sensorslist') }
Vue.prototype.Maglink.SaveSensor = (item) => { return http.post(API_URL + '/api/v1/sensor', item) }
Vue.prototype.Maglink.DeleteSensor = (id) => { return http.delete(API_URL + '/api/v1/sensor/' + id) }

// Autodetection
Vue.prototype.Maglink.GetPiggyback = () => { return http.get(API_URL + '/api/v1/piggyback') }
Vue.prototype.Maglink.GetAutodetectionStatus = () => { return http.get(API_URL + '/api/v1/autodetection_status') }
Vue.prototype.Maglink.GetAutodetections = () => { return http.get(API_URL + '/api/v1/autodetections') }
Vue.prototype.Maglink.StartAutodetection = (module, address) => { return http.post(API_URL + '/api/v1/autodetection_start', { module: module == null ? 0 : module, moduleAddress: address == null ? 0 : address, position: 0, subPosition: 0 }) }

// LLD
Vue.prototype.Maglink.GetLlds = () => { return http.get(API_URL + '/api/v1/llds') }
Vue.prototype.Maglink.GetLldsHeaders = () => { return http.get(API_URL + '/api/v1/llds_headers') }
Vue.prototype.Maglink.SaveLld = (item) => { return http.post(API_URL + '/api/v1/lld', item) }
Vue.prototype.Maglink.DeleteLld = (item) => { return http.delete(API_URL + '/api/v1/lld/' + item) }
Vue.prototype.Maglink.StatusLldCalibration = () => { return http.get(API_URL + '/api/v1/lld_calibration_status') }
Vue.prototype.Maglink.BetaCalibrationStart = (data) => { return http.post(API_URL + '/api/v1/lld_calibration_start', data) }
Vue.prototype.Maglink.BetaCalibrationStop = (data) => { return http.post(API_URL + '/api/v1/lld_calibration_stop', data) }
Vue.prototype.Maglink.GetScheduledLeakTests = () => { return http.get(API_URL + '/api/v1/scheduled_lld_leak_tests') }
Vue.prototype.Maglink.GetLldLeakTestStatuses = () => { return http.get(API_URL + '/api/v1/lld_leak_test_status') }
Vue.prototype.Maglink.ApplyScheduledLeakTest = (data) => { return http.post(API_URL + '/api/v1/scheduled_lld_leak_test', data) }
Vue.prototype.Maglink.DeleteScheduledTest = (lld) => { return http.delete(API_URL + '/api/v1/scheduled_lld_leak_test/' + lld) }
Vue.prototype.Maglink.StartLldLeakTest = (lld, type) => { return http.post(API_URL + '/api/v1/lld_leakage_start/' + lld + '?type=' + type) }
Vue.prototype.Maglink.StopLldLeakTest = (lld) => { return http.post(API_URL + '/api/v1/lld_leakage_stop/' + lld) }
Vue.prototype.Maglink.StpShutdownSetup = (data) => { return http.post(API_URL + '/api/v1/stp_shutdown', data) }
// ACR
Vue.prototype.Maglink.GetCalibration = (tank) => { return http.get(API_URL + '/api/v1/calibration/' + tank) }
Vue.prototype.Maglink.TankCalibrationStart = (tankNumber, type) => { return http.post(API_URL + '/api/v1/calibration_start/' + tankNumber + '?type=' + type) }
Vue.prototype.Maglink.TankCalibrationStop = (tankNumber) => { return http.post(API_URL + '/api/v1/calibration_stop/' + tankNumber) }
Vue.prototype.Maglink.TankSelectStraptable = (tankNumber, table) => { return http.post(API_URL + '/api/v1/calibration_select_table/' + tankNumber + '?table=' + table) }
Vue.prototype.Maglink.GetCalibrationEvaluation = (tank, days) => { return http.get(API_URL + '/api/v1/calibration_evaluation/' + tank + '?days=' + days) }

// login and current user
Vue.prototype.Maglink.Login = (user) => { return http.post(API_URL + '/login', user) }
Vue.prototype.Maglink.CurrentUser = () => { return http.get(API_URL + '/api/v1/user') }
Vue.prototype.Maglink.ChangePassword = (password) => { return http.post(API_URL + '/api/v1/change_password', password) }

// options
Vue.prototype.Maglink.GetOptions = () => { return http.get(API_URL + '/api/v1/options', { cache: true }) }

// contacts
Vue.prototype.Maglink.GetContacts = () => { return http.get(API_URL + '/api/v1/contacts') }
Vue.prototype.Maglink.SaveContact = (contact) => { return http.post(API_URL + '/api/v1/contacts', contact) }
Vue.prototype.Maglink.DeleteContact = (id) => { return http.delete(API_URL + '/api/v1/contacts/' + id) }

Vue.prototype.Maglink.GetShifts = () => { return http.get(API_URL + '/api/v1/settings/Shifts') }
Vue.prototype.Maglink.SaveShifts = (item) => { return http.post(API_URL + '/api/v1/settings/Shifts', item) }
Vue.prototype.Maglink.ReportShifts = (item) => { return http.post(API_URL + '/api/v1/report_shifts', item) }

Vue.prototype.Maglink.GetOpenClose = () => { return http.get(API_URL + '/api/v1/settings/ScheduledOpenClose') }
Vue.prototype.Maglink.SaveOpenClose = (item) => { return http.post(API_URL + '/api/v1/settings/ScheduledOpenClose', item) }

// notifications
Vue.prototype.Maglink.GetNotifications = () => { return http.get(API_URL + '/api/v1/notifications') }
Vue.prototype.Maglink.SetNotifications = (notifications) => { return http.post(API_URL + '/api/v1/notifications', notifications) }

// tanks
Vue.prototype.Maglink.GetTankStatus = (tankNumber) => { return http.get(API_URL + '/api/v1/tank_status/' + tankNumber.toString()) }
Vue.prototype.Maglink.SaveTank = (tank) => {
  let { relays, straptable, lastAlarm, lastMeasurement, ...smallTank } = tank
  return http.post(API_URL + '/api/v1/tank', smallTank)
}
// users
Vue.prototype.Maglink.GetUsers = () => { return http.get(API_URL + '/api/v1/users') }

// language
Vue.prototype.Maglink.GetLanguages = () => { return http.get(API_URL + '/languages_all') }
Vue.prototype.Maglink.GetLanguage = (lang) => { return http.get(API_URL + '/languages?type=1&lang=' + lang) }
Vue.prototype.Maglink.PostLanguage = (type, text) => { return http.post(API_URL + '/languages?type=' + type, text) }
Vue.prototype.Maglink.GetCountries = () => { return http.get(API_URL + '/api/v1/countries') }
Vue.prototype.Maglink.GetDictionaries = (filters) => { return http.post(API_URL + '/api/v1/dictionaries', filters) }
Vue.prototype.Maglink.UpdateDictionary = (item) => { return http.post(API_URL + '/api/v1/update_dictionary', item) }
Vue.prototype.Maglink.AuthenticateTranslation = (item) => { return http.post(API_URL + '/api/v1/authenticate_translation', item) }
Vue.prototype.Maglink.SendTestEmail = (item) => { return http.post(API_URL + '/api/v1/smtp_test', item) }

// utility --> update, backup, restore, download
// --------------------------------------------------------------------------------------------------------------------
Vue.prototype.Maglink.ConsoleUpdate = (item) => { return http.post(API_URL + '/api/v1/utility/console_update', item) }

Vue.prototype.Maglink.UploadBackupDb = (item) => { return http.post(API_URL + '/api/v1/backupdb/upload/db', item) }
Vue.prototype.Maglink.UploadBackupConfig = (item) => { return http.post(API_URL + '/api/v1/backupdb/upload/config', item) }
Vue.prototype.Maglink.RestoreRemoteBackup = () => { return http.get(API_URL + '/api/v1/backupdb/restore') }

Vue.prototype.Maglink.ConsoleReboot = (item) => { return http.post(API_URL + '/api/v1/utility/console_reboot', item) }

Vue.prototype.Maglink.GetLogList = () => { return http.get(API_URL + '/api/v1/log/list') }
Vue.prototype.Maglink.LogDownload = (item) => { return http.get(API_URL + '/api/v1/log/download/' + item, { responseType: 'arraybuffer' }) }
Vue.prototype.Maglink.DeleteLog = (item) => { return http.post(API_URL + '/api/v1/log/delete/' + item) }
Vue.prototype.Maglink.UploadLogLevel = (item) => { return http.post(API_URL + '/api/v1/log/level', item) }

Vue.prototype.Maglink.GetBackupList = () => { return http.get(API_URL + '/api/v1/backupdb/list') }
Vue.prototype.Maglink.BackupDownload = (item) => { return http.get(API_URL + '/api/v1/backupdb/download/' + item, { responseType: 'arraybuffer' }) }
Vue.prototype.Maglink.CreateNewBackup = () => { return http.post(API_URL + '/api/v1/backupdb/new') }
Vue.prototype.Maglink.DeleteBackup = (item) => { return http.post(API_URL + '/api/v1/backupdb/delete/' + item) }
Vue.prototype.Maglink.RestoreLocaleBackup = (item) => { return http.post(API_URL + '/api/v1/backupdb/restorelocale/' + item) }
Vue.prototype.Maglink.ResetConsole = (item) => { return http.post(API_URL + '/api/v1/console/reset/' + item) }
Vue.prototype.Maglink.ResetCsldData = (filters) => { return http.post(API_URL + '/api/v1/csld_data_reset', filters) }

Vue.prototype.Maglink.UploadLicense = (item) => { return http.post(API_URL + '/api/v1/utility/license_update', item) }

// --------------------------------------------------------------------------------------------------------------------

Vue.prototype.Maglink.SaveTankRelays = (tank) => {
  return http.post(API_URL + '/api/v1/tank_relays', {
    tankNumber: tank.tankNumber,
    relays: tank.relays
  })
}
Vue.prototype.Maglink.SaveTankStrap = (tank) => {
  return http.post(API_URL + '/api/v1/tank_strap', {
    tankNumber: tank.tankNumber,
    straptable: tank.straptable,
    tankSerialize: tank.serialize
  })
}

Vue.prototype.Maglink.AckSensor = (sensorNumber) => { return http.post(API_URL + '/api/v1/sensor_ack/' + sensorNumber) }

Vue.prototype.Maglink.AckLld = (lldNumber) => { return http.post(API_URL + '/api/v1/lld_ack/' + lldNumber) }

Vue.prototype.Maglink.GetTanks = () => { return http.get(API_URL + '/api/v1/tanks') }
Vue.prototype.Maglink.GetTanksHeaders = () => { return http.get(API_URL + '/api/v1/tanks_headers') }
Vue.prototype.Maglink.AckTank = (tankNumber) => { return http.post(API_URL + '/api/v1/tank_ack/' + tankNumber) }
Vue.prototype.Maglink.TankLeakageStart = (tankNumber, type) => { return http.post(API_URL + '/api/v1/tank_leakage_start/' + tankNumber + '?type=' + type) }
Vue.prototype.Maglink.TankLeakageStop = (tankNumber) => { return http.post(API_URL + '/api/v1/tank_leakage_stop/' + tankNumber) }

Vue.prototype.Maglink.GetTanksGroups = () => { return http.get(API_URL + '/api/v1/tanks_groups') }
// Vue.prototype.Maglink.SaveTanksGroups = (groups) => { return http.post(API_URL + '/api/v1/tanks_groups', groups) }
Vue.prototype.Maglink.SaveTankGroup = (item) => { return http.post(API_URL + '/api/v1/save_tank_group', item) }
Vue.prototype.Maglink.DeleteTankGroup = (group) => { return http.post(API_URL + '/api/v1/delete_tank_group', group) }
Vue.prototype.Maglink.GetTanksGroupsStatus = () => { return http.get(API_URL + '/api/v1/tanks_groups_inventory') }

// maintenance
Vue.prototype.Maglink.SetNetwork = (network) => { return http.post(API_URL + '/api/v1/utility/network', network) }
Vue.prototype.Maglink.GetNetwork = () => { return http.get(API_URL + '/api/v1/utility/network') }
Vue.prototype.Maglink.GetTimezone = () => { return http.get(API_URL + '/api/v1/utility/timezone') }
Vue.prototype.Maglink.SetTimezone = (timezone, date) => { return http.post(API_URL + '/api/v1/utility/timezone', { timezone, date }) }

// reports
Vue.prototype.Maglink.GetReportTankAlarms = (filters) => { return http.post(API_URL + '/api/v1/report_alarms', filters) }
Vue.prototype.Maglink.GetReportSensorAlarms = (filters) => { return http.post(API_URL + '/api/v1/report_sensor_alarms', filters) }
Vue.prototype.Maglink.GetReportLldAlarms = (filters) => { return http.post(API_URL + '/api/v1/report_lld_alarms', filters) }
Vue.prototype.Maglink.GetReportDeliveries = (filters) => { return http.post(API_URL + '/api/v1/report_deliveries', filters) }
Vue.prototype.Maglink.GetReportLeakages = (filters) => { return http.post(API_URL + '/api/v1/report_leakages', filters) }
Vue.prototype.Maglink.GetReportLldLeakTests = (filters) => { return http.post(API_URL + '/api/v1/report_lld_leakages', filters) }
Vue.prototype.Maglink.GetReportHistory = (filters) => { return http.post(API_URL + '/api/v1/report_history', filters) }
Vue.prototype.Maglink.GetReportSales = (filters) => { return http.post(API_URL + '/api/v1/report_sales', filters) }

Vue.prototype.Maglink.GetCsldCounters = (tankNumber) => { return http.get(API_URL + '/api/v1/report_sld_counters/' + tankNumber.toString()) }
Vue.prototype.Maglink.GetReportCsldLeakages = (filters) => { return http.post(API_URL + '/api/v1/report_sld_leakages', filters) }
Vue.prototype.Maglink.GetReportCsldDailyDiagnostics = (filters) => { return http.post(API_URL + '/api/v1/report_sld_daily_diagnostics', filters) }
Vue.prototype.Maglink.GetReportCsldSegments = (tankNumber) => { return http.get(API_URL + '/api/v1/report_sld_segments/' + tankNumber.toString()) }

Vue.prototype.Maglink.GetReportProductVolume = (filters) => { return http.post(API_URL + '/api/v1/report_product_volume', filters) }

// TODO: TEST NEW API's
// *******************************************************************************************************************************************************************
// *******************************************************************************************************************************************************************
// *******************************************************************************************************************************************************************
Vue.prototype.Maglink.GetReportShifts = (filters) => { return http.post(API_URL + '/api/v1/report_shifts', filters) }
Vue.prototype.Maglink.SaveShiftsSchedule = (item) => { return http.post(API_URL + '/api/v1/save_shifts', item) }
Vue.prototype.Maglink.GetShiftsSchedule = (item) => { return http.get(API_URL + '/api/v1/read_shifts') }

Vue.prototype.Maglink.GetCalibrationSettings = (tankNumber) => { return http.get(API_URL + '/api/v1/calibration/' + tankNumber.toString()) }
Vue.prototype.Maglink.SaveCalibrationSettings = (item) => { return http.post(API_URL + '/api/v1/calibration/' + item) }
Vue.prototype.Maglink.CalibrationAction = (tankNumber, action) => { return http.post(API_URL + '/api/v1/calibration_process/' + tankNumber + '?action=' + action) }

Vue.prototype.Maglink.GetReportReconciliation = (filters) => { return http.post(API_URL + '/api/v1/report_reconciliation', filters) }

Vue.prototype.Maglink.GetReportComplianceTank = (filters) => { return http.post(API_URL + '/api/v1/report_tank_compliance', filters) }
Vue.prototype.Maglink.GetReportComplianceLld = (filters) => { return http.post(API_URL + '/api/v1/report_lld_compliance', filters) }
Vue.prototype.Maglink.GetReportComplianceSensor = (filters) => { return http.post(API_URL + '/api/v1/report_sensor_compliance', filters) }

Vue.prototype.Maglink.GetScheduledTankLeakTests = () => { return http.get(API_URL + '/api/v1/scheduled_tank_leak_tests') }
Vue.prototype.Maglink.SaveScheduledTankLeakTest = (item) => { return http.post(API_URL + '/api/v1/scheduled_tank_leak_test', item) }
Vue.prototype.Maglink.DeleteScheduledTankLeakTest = (tankNumber) => { return http.delete(API_URL + '/api/v1/scheduled_tank_leak_test/' + tankNumber) }

// *******************************************************************************************************************************************************************
// *******************************************************************************************************************************************************************
// *******************************************************************************************************************************************************************

// lang common settings ***********************************************************************************
Vue.prototype.Maglink.NoDataMessage = (isFilter) => {
  let tt = i18n.t('No data available')

  if (isFilter) tt = i18n.t('No data available for this filter')

  return tt.toUpperCase()
}
// ********************************************************************************************************

// GRAPH SECTION ***********************************************************************************
Vue.prototype.Maglink.GetGraphTimeline = (series1, series2, axisX, unit, valueType, title) => {
  // valueType: 1=vol; 2=level; 3=date; 4=density; 5=weight; 6=temperature
  let chart = {
    data: {
      labels: [],
      series: [[], []]
    },
    options: {
      lineSmooth: 1,
      low: 0,
      high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
      color: 'green',
      perc: 0,
      firstY: undefined,
      lastY: undefined,
      firstX: undefined,
      lastX: undefined,
      title: '',
      chartPadding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      }
    }
  }

  let exist = (series2 !== undefined)
  let minVolume = 0
  let maxVolume = 0
  if (exist) {
    minVolume = Math.min.apply(Math, series1.concat(series2))
    maxVolume = Math.max.apply(Math, series1.concat(series2))
  } else {
    minVolume = Math.min.apply(Math, series1)
    maxVolume = Math.max.apply(Math, series1)
  }

  let offset = (maxVolume - minVolume) / 10
  if ((!exist) && (offset < (maxVolume * 0.02))) {
    offset = maxVolume * 0.02
  }

  minVolume -= offset
  maxVolume += offset
  chart.options.firstY = series1[0]
  chart.options.lastY = series1[series1.length - 1]

  if (valueType === 1) {
    chart.options.low = Vue.prototype.Maglink.VolumeToDisplay(minVolume, unit) * 1
    chart.options.high = Vue.prototype.Maglink.VolumeToDisplay(maxVolume, unit) * 1
  } else if (valueType === 2) {
    chart.options.low = Vue.prototype.Maglink.LevelToDisplay(minVolume, unit) * 1
    chart.options.high = Vue.prototype.Maglink.LevelToDisplay(maxVolume, unit) * 1
  } else if (valueType === 4) {
    chart.options.low = minVolume
    chart.options.high = maxVolume
  } else if (valueType === 6) {
    chart.options.low = minVolume
    chart.options.high = maxVolume
  }

  chart.options.perc = (100 * (chart.options.lastY - chart.options.firstY)) / chart.options.lastY
  chart.options.color = chart.options.perc >= 0 ? 'green' : 'red'

  if (valueType === 1) {
    for (let i = 0; i < series1.length; i++) {
      series1[i] = Vue.prototype.Maglink.VolumeToDisplay(series1[i], unit)

      if (exist) {
        series2[i] = Vue.prototype.Maglink.VolumeToDisplay(series2[i], unit)
      }
    }
  } else if (valueType === 1) {
    for (let i = 0; i < series1.length; i++) {
      series1[i] = Vue.prototype.Maglink.LevelToDisplay(series1[i], unit)

      if (exist) {
        series2[i] = Vue.prototype.Maglink.LevelToDisplay(series2[i], unit)
      }
    }
  } else if (valueType === 4) {
  } else if (valueType === 6) {
  }

  chart.data.series = []
  chart.data.series.push(series1)
  if (exist) {
    chart.data.series.push(series2)
  }
  if (axisX !== undefined) {
    chart.data.labels = axisX
  }

  chart.options.title = (title !== undefined) ? title : ''

  return chart
}
// ********************************************************************************************************

// ********************************************************************************************************
Vue.prototype.Maglink.ToDisplay = (item, levelUnit, volumeUnit, temperatureUnit) => {
  let itemConverted = Object.assign({}, item) // clone
  Object.keys(itemConverted).forEach(function (key, index) {
    itemConverted[key] = Vue.prototype.Maglink.ConvertValue(key, itemConverted[key], levelUnit, volumeUnit, temperatureUnit)
  })
  return itemConverted
}
Vue.prototype.Maglink.ConvertValue = (key, value, levelUnit, volumeUnit, temperatureUnit) => {
  let fieldsVol = ['startDelivery', 'acrEndDelivery', 'theftThreshold', 'unexpectedSaleThreshold', 'ullage']
  if (key.endsWith('Volume') || key.endsWith('VolumeComp') || (fieldsVol.indexOf(key) >= 0)) {
    return Vue.prototype.Maglink.VolumeToDisplay(value, volumeUnit)
  } else if (key.endsWith('Level')) {
    return Vue.prototype.Maglink.LevelToDisplay(value, levelUnit)
  } else if (key.endsWith('Leakage')) {
    return Vue.prototype.Maglink.LeakageToDisplay(value, volumeUnit)
  } else if (key.endsWith('Temperature') || key.startsWith('temperature')) {
    return Vue.prototype.Maglink.TemperatureToDisplay(value, temperatureUnit)
  } else if (key === 'delivery' || key === 'leakage' || key === 'suddenLoss' || key === 'lastAlarm' || key === 'lastMeasurement') {
    let subItems = value
    Object.keys(subItems).forEach(function (subKey, index) {
      subItems[subKey] = Vue.prototype.Maglink.ConvertValue(subKey, subItems[subKey], levelUnit, volumeUnit)
    })
    return subItems
  } else if (key.startsWith('weight')) {
    return Vue.prototype.Maglink.RoundFormat(value, 2)
  }
  // no convertion needed
  return value

  // typeof v==='object' && v!==null && !(v instanceof Array) && !(v instanceof Date)
}
// *********************************************************************************************************
Vue.prototype.Maglink.FromDisplay = (item, levelUnit, volumeUnit) => {
  let itemConverted = Object.assign({}, item) // clone
  Object.keys(itemConverted).forEach(function (key, index) {
    itemConverted[key] = Vue.prototype.Maglink.UnConvertValue(key, itemConverted[key], levelUnit, volumeUnit)
  })
  return itemConverted
}
Vue.prototype.Maglink.UnConvertValue = (key, value, levelUnit, volumeUnit) => {
  // check volume values
  let fields = ['startDelivery', 'acrEndDelivery', 'theftThreshold', 'unexpectedSaleThreshold']
  let isVolume = key.endsWith('Volume') || key.endsWith('VolumeComp') || (fields.indexOf(key) >= 0)
  if (isVolume) {
    return Vue.prototype.Maglink.VolumeFromDisplay(value, volumeUnit)
  }

  // check level values
  let isLevel = key.endsWith('Level')
  if (isLevel) {
    return Vue.prototype.Maglink.LevelFromDisplay(value, levelUnit)
  }

  // check groups
  fields = ['delivery', 'leakage', 'suddenLoss', 'lastAlarm', 'lastMeasurement', 'acrThresholds', 'reports']
  let isGroup = fields.indexOf(key) >= 0
  if (isGroup) {
    let subItems = value
    Object.keys(subItems).forEach(function (subKey, index) {
      subItems[subKey] = Vue.prototype.Maglink.UnConvertValue(subKey, subItems[subKey], levelUnit, volumeUnit)
    })
    return subItems
  }

  // no convertion needed
  return value

  // typeof v==='object' && v!==null && !(v instanceof Array) && !(v instanceof Date)
}
// *********************************************************************************************************
Vue.prototype.Maglink.LevelToDisplay = (level, unit) => {
  var levelConv = [1, 10, 25.4][unit]
  return Vue.prototype.Maglink.LevelFormat(level / levelConv, unit)
}
Vue.prototype.Maglink.LevelFromDisplay = (level, unit) => {
  var levelConv = [1, 10, 25.4][unit]
  return level * levelConv
}
Vue.prototype.Maglink.VolumeToDisplay = (vol, unit) => {
  var volConv = [1, 3.78541][unit]
  return Vue.prototype.Maglink.VolumeFormat(vol / volConv, unit)
}
Vue.prototype.Maglink.VolumeFromDisplay = (vol, unit) => {
  var volConv = [1, 3.78541][unit]
  return vol * volConv
}
Vue.prototype.Maglink.TemperatureToDisplay = (temperature, unit) => {
  var tempConv = temperature
  if (unit === 2) {
    tempConv = temperature * 9.0 / 5.0 + 32.0
  }
  return Vue.prototype.Maglink.TemperatureFormat(tempConv, unit)
}
Vue.prototype.Maglink.TemperaureFromDisplay = (temperature, unit) => {
  var tempConv = temperature
  if (unit === 2) {
    tempConv = (temperature - 32.0) * 5.0 / 9.0
  }
  return tempConv
}
Vue.prototype.Maglink.TemperatureSlopeToDisplay = (temperature, unit) => {
  var tempConv = temperature
  if (unit === 2) {
    tempConv = temperature * 9.0 / 5.0
  }

  return Vue.prototype.Maglink.TemperatureFormat(tempConv, unit)
}
Vue.prototype.Maglink.LeakageToDisplay = (leak, unit) => {
  var leakConv = [1, 3.78541][unit]
  return Vue.prototype.Maglink.LeakageFormat(leak / leakConv, unit)
}
Vue.prototype.Maglink.LeakageFromDisplay = (leak, unit) => {
  var leakConv = [1, 3.78541][unit]
  return leak * leakConv
}
Vue.prototype.Maglink.LeakShortUdm = (unit) => {
  if (unit === undefined || unit === 0) {
    return i18n.t('lph')
  }
  return i18n.t('gph')
}

// *********************************************************************************************************
Vue.prototype.Maglink.OffsetToLocalTime = -(new Date().getTimezoneOffset()) / 60
Vue.prototype.Maglink.GetUtcToLocalTime = (utcTime) => {
  let dt = new Date(utcTime)
  dt.setHours(dt.getHours() + Vue.prototype.Maglink.OffsetToLocalTime)

  return { date: dt, number: dt.getTime() }
}
Vue.prototype.Maglink.GetLocalToUtcTime = (localeTime) => {
  let dt = new Date(localeTime)
  dt.setHours(dt.getHours() - Vue.prototype.Maglink.OffsetToLocalTime)

  return { date: dt, number: dt.getTime() }
}

// format date based upon settings
Vue.prototype.Maglink.GetCustomDate = (dt, outputFormat) => {
  const toTwoDigits = num => num < 10 ? '0' + num : num
  let year = dt.getFullYear()
  let month = toTwoDigits(dt.getMonth() + 1)
  let day = toTwoDigits(dt.getDate())

  if (year < 1971) return `--`

  outputFormat = outputFormat.toLowerCase()
  if (outputFormat === 'dd-mm-yyyy') return `${day}-${month}-${year}`
  if (outputFormat === 'mm-dd-yyyy') return `${month}-${day}-${year}`
  if (outputFormat === 'yyyy-mm-dd') return `${year}-${month}-${day}`
  if (outputFormat === 'yyyymmdd') return `${year}${month}${day}`

  return `${day}-${month}-${year}`
}
Vue.prototype.Maglink.GetCustomDateTime = (dateInt, outputFormat) => {
  let dt = new Date(dateInt * 1000)
  const toTwoDigits = num => num < 10 ? '0' + num : num
  let year = dt.getFullYear()

  if (isNaN(year)) return '--'
  if (year < 1971) return `--`

  let month = toTwoDigits(dt.getMonth() + 1)
  let day = toTwoDigits(dt.getDate())
  let hour = toTwoDigits(dt.getHours())
  let minutes = toTwoDigits(dt.getMinutes())
  let secs = toTwoDigits(dt.getSeconds())
  let result = `${day}-${month}-${year}`

  outputFormat = outputFormat.toLowerCase()
  if (outputFormat === 'dd-mm-yyyy') {
    result = `${day}-${month}-${year}`
  } else if (outputFormat === 'mm-dd-yyyy') {
    result = `${month}-${day}-${year}`
  } else if (outputFormat === 'yyyy-mm-dd') {
    result = `${year}-${month}-${day}`
  }

  result += ` ${hour}:${minutes}:${secs}`
  return result
}
Vue.prototype.Maglink.GetCustomTimeFromUTCMs = (milliSecInt) => {
  let dt = new Date(milliSecInt)
  const toTwoDigits = num => num < 10 ? '0' + num : num

  let hour = toTwoDigits(dt.getUTCHours())
  let minutes = toTwoDigits(dt.getMinutes())
  let secs = toTwoDigits(dt.getSeconds())
  let result = `${hour}:${minutes}:${secs}`
  return result
}
Vue.prototype.Maglink.GetCustomTime = (dateInt) => {
  let dt = new Date(dateInt * 1000)
  const toTwoDigits = num => num < 10 ? '0' + num : num

  let hour = toTwoDigits(dt.getHours())
  let minutes = toTwoDigits(dt.getMinutes())
  let secs = toTwoDigits(dt.getSeconds())
  let result = `${hour}:${minutes}:${secs}`
  return result
}
Vue.prototype.Maglink.GetDateTime = (dt) => {
  if (dt.getFullYear() < 1971) return `--`
  return [dt.getFullYear(), (dt.getMonth() + 1).padding(), dt.getDate().padding()].join('-') +
          ' ' + [dt.getHours().padding(), dt.getMinutes().padding(), dt.getSeconds().padding()].join(':')
}
Vue.prototype.Maglink.GetCurrentDate = () => {
  let dt = new Date()
  return Vue.prototype.Maglink.GetCustomDate(dt, 'yyyy-mm-dd')
}

Vue.prototype.Maglink.GetCustomDateTimeInZone = (dateInt, zoneName, outputFormat) => {
  let dt = new Date(dateInt * 1000)
  let options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23', timeZone: zoneName }
  var format

  try {
    format = Intl.DateTimeFormat('en-GB', options)
  } catch (error) {
  }

  if (format === undefined || format === '') {
    return Vue.prototype.Maglink.GetCustomDateTime(dateInt, outputFormat)
  }
  let formatted = format.format(dt)

  let dateItems = formatted.split(',')[0].split('/')
  let timeItems = formatted.split(',')[1].split(':')
  let newDate = new Date(+(dateItems[2] * 1), (dateItems[1] * 1) - 1, +(dateItems[0] * 1), +(timeItems[0] * 1), +(timeItems[1] * 1), +(timeItems[2] * 1))

  return Vue.prototype.Maglink.GetCustomDateTime(newDate.getTime() / 1000, outputFormat)
}

Vue.prototype.Maglink.GetDayHourMinuteSecondFormatOfSeconds = (totalSeconds) => {
  if (totalSeconds < 0) return ' -- '

  let hours = Math.floor(totalSeconds / 3600)
  let minutes = Math.floor(totalSeconds / 60) - (hours * 60)
  let seconds = totalSeconds - (minutes * 60) - (hours * 3600)

  let days = Math.floor(hours / 24)
  hours = hours - (days * 24)

  if (days === 0 && hours === 0 && minutes === 0) return seconds + i18n.t('s')
  if (days === 0 && hours === 0) return minutes + i18n.t('m') + ' ' + seconds + i18n.t('s')
  if (days === 0) return hours + i18n.t('h') + ' ' + minutes + i18n.t('m') + ' ' + seconds + i18n.t('s')
  return days + i18n.t('d') + ' ' + hours + i18n.t('h') + ' ' + minutes + i18n.t('m') + ' ' + seconds + i18n.t('s')
}
Vue.prototype.Maglink.GetHourMinuteSecondFormatOfSeconds = (totalSeconds) => {
  if (totalSeconds < 0) return ' -- '

  let hours = Math.floor(totalSeconds / 3600)
  let minutes = Math.floor(totalSeconds / 60) - (hours * 60)
  let seconds = totalSeconds - (minutes * 60) - (hours * 3600)
  if (hours === 0 && minutes === 0) return seconds + i18n.t('s')
  if (hours === 0) return minutes + i18n.t('m') + ' ' + seconds + i18n.t('s')
  return hours + i18n.t('h') + ' ' + minutes + i18n.t('m') + ' ' + seconds + i18n.t('s')
}

Vue.prototype.Maglink.GetMinuteSecondFormatOfSeconds = (totalSeconds) => {
  if (totalSeconds < 0) return ' -- '

  let minutes = Math.floor(totalSeconds / 60)
  let seconds = totalSeconds - (minutes * 60)
  if (minutes === 0) return seconds + i18n.t('s')
  return minutes + i18n.t('m') + ' ' + seconds + i18n.t('s')
}

Vue.prototype.Maglink.GetDayHourMinuteSecondFormat = (initial, final) => {
  let totalSeconds = Vue.prototype.Maglink.GetTimeDiffInSeconds(initial, final)
  return Vue.prototype.Maglink.GetDayHourMinuteSecondFormatOfSeconds(totalSeconds)
}
Vue.prototype.Maglink.GetHourMinuteSecondFormat = (initial, final) => {
  let totalSeconds = Vue.prototype.Maglink.GetTimeDiffInSeconds(initial, final)
  return Vue.prototype.Maglink.GetHourMinuteSecondFormatOfSeconds(totalSeconds)
}

Vue.prototype.Maglink.GetMinuteSecondFormat = (initial, final) => {
  let totalSeconds = Vue.prototype.Maglink.GetTimeDiffInSeconds(initial, final)
  return Vue.prototype.Maglink.GetMinuteSecondFormatOfSeconds(totalSeconds)
}

Vue.prototype.Maglink.GetTimeDiffInSeconds = (initial, final) => {
  let fromTime = new Date(initial * 1000)
  let toTime = new Date(final * 1000)
  let totalSeconds = toTime.getTime() - fromTime.getTime()
  totalSeconds = Math.floor((totalSeconds) / (1000))

  return totalSeconds
}
Vue.prototype.Maglink.GetDayHoursFormat = (initial, final) => {
  let totalSeconds = Vue.prototype.Maglink.GetTimeDiffInSeconds(initial, final)
  if (totalSeconds < 0) return ' -- '

  let hours = Math.floor(totalSeconds / 3600)
  let days = Math.floor(hours / 24)
  hours = hours - (days * 24)

  if (days === 0) return hours + ' ' + i18n.t('hours')
  return days + ' ' + i18n.t('days') + ' ' + hours + ' ' + i18n.t('hours')
}

Vue.prototype.Maglink.GetMonthName = (dt) => {
  let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  var monthName = months[dt.getMonth()]
  return i18n.t(monthName)
}

Vue.prototype.Maglink.GetSensorAlarmImage = (item, channelIndex) => {
  let result = 0 // 0=ok; 1=alarm; 2=ack; 9=json problem

  if (item === undefined || item.readingChannels === undefined || item.readingChannels[channelIndex] === undefined) {
    result = 9
  } else if (item.readingChannels[channelIndex].value === 1) {
    if (item.lastAlarm.ackStatus === 2) {
      result = 2
    } else {
      result = 1
    }
  }

  return Vue.prototype.Maglink.GetImageAlarm(result)
}

Vue.prototype.Maglink.GetImageAlarm = (code) => {
  return './img/alarm/alarm_status_' + code + '.png'
}
Vue.prototype.Maglink.GetAckDescription = (ackStatus) => {
  return [i18n.t('Ok').toUpperCase(), i18n.t('Alarm').toUpperCase(), i18n.t('Ack').toUpperCase()][ackStatus]
}
Vue.prototype.Maglink.GetStatusInfo = (statusCode) => {
  if (statusCode === 0) return { statusDesc: i18n.t('Ok').toUpperCase(), alarmCount: 0 }

  let result = []

  if ((statusCode & 32) === 32) result.push(i18n.t('NO LINK'))
  if ((statusCode & 512) === 512) result.push(i18n.t('DATA ERROR'))
  if ((statusCode & 1024) === 1024) result.push(i18n.t('COMMUNICATION'))
  if ((statusCode & 128) === 128) result.push(i18n.t('NOT INITIALIZED'))
  if ((statusCode & 256) === 256) result.push(i18n.t('OUT OF SCALE'))
  if ((statusCode & 16) === 16) result.push(i18n.t('HIGH/HIGH'))
  if ((statusCode & 2) === 2) result.push(i18n.t('LOW/LOW'))
  if ((statusCode & 1) === 1) result.push(i18n.t('WATER'))
  if ((statusCode & 4) === 4) result.push(i18n.t('LOW'))
  if ((statusCode & 8) === 8) result.push(i18n.t('HIGH'))
  if ((statusCode & 64) === 64) result.push(i18n.t('DISABLED'))
  if ((statusCode & (2 * 1024)) === (2 * 1024)) result.push(i18n.t('ETHANOL'))
  if ((statusCode & (4 * 1024)) === (4 * 1024)) result.push(i18n.t('LEAK'))
  if ((statusCode & (8 * 1024)) === (8 * 1024)) result.push(i18n.t('ACTIVE'))
  if ((statusCode & (16 * 1024)) === (16 * 1024)) result.push(i18n.t('OPEN'))
  if ((statusCode & (32 * 1024)) === (32 * 1024)) result.push(i18n.t('SHORT'))
  if ((statusCode & (64 * 1024)) === (64 * 1024)) result.push(i18n.t('LIQUID WARNINING'))
  if ((statusCode & (128 * 1024)) === (128 * 1024)) result.push(i18n.t('LIQUID HIGH'))
  if ((statusCode & (256 * 1024)) === (256 * 1024)) result.push(i18n.t('VAPOR'))
  if ((statusCode & (512 * 1024)) === (512 * 1024)) result.push(i18n.t('STP CONTROLLER'))
  if ((statusCode & (1024 * 1024)) === (1024 * 1024)) result.push(i18n.t('NO LEAK TEST'))
  if ((statusCode & (2048 * 1024)) === (2048 * 1024)) result.push(i18n.t('NO ANNUAL LEAK TEST'))
  if ((statusCode & (4096 * 1024)) === (4096 * 1024)) result.push(i18n.t('NO STP LINK'))
  if ((statusCode & (8192 * 1024)) === (8192 * 1024)) result.push(i18n.t('PRESSURE LOW'))
  if ((statusCode & (16384 * 1024)) === (16384 * 1024)) result.push(i18n.t('SUDDEN LOSS'))
  if ((statusCode & (32768 * 1024)) === (32768 * 1024)) result.push(i18n.t('HH WATER'))
  if ((statusCode & (65536 * 1024)) === (65536 * 1024)) result.push(i18n.t('MANIFOLD BROKEN'))

  return { statusDesc: result.join(',').toUpperCase(), alarmCount: result.length }
}
Vue.prototype.Maglink.GetTankColors = () => {
  let tankColor = [0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
  tankColor[0] = 'blue'
  tankColor[1] = 'black'
  tankColor[2] = 'yellow'
  tankColor[3] = 'yellow'
  tankColor[4] = 'yellow'
  tankColor[5] = 'yellow'
  tankColor[6] = 'yellow'
  tankColor[7] = 'orange'
  tankColor[8] = 'orange'
  tankColor[9] = 'black'
  tankColor[10] = 'green'
  tankColor[11] = 'green'
  tankColor[12] = 'green'
  tankColor[13] = 'green'
  tankColor[14] = 'green'
  tankColor[15] = 'green'
  tankColor[16] = 'green'
  tankColor[17] = 'yellow'
  tankColor[18] = 'black'
  tankColor[19] = 'blue'
  tankColor[20] = 'blue'
  tankColor[21] = 'black'
}
Vue.prototype.Maglink.GetLineStatusInfo = (statusCode) => {
  if (statusCode === 0) return { statusDesc: i18n.t('IDLE').toUpperCase(), alarmCount: 0 }

  let result = []

  if ((statusCode & 15) !== 0) result.push(i18n.t('ERROR'))
  if ((statusCode & 16) === 16) result.push(i18n.t('FAILED TO TURN STP ON'))
  if ((statusCode & 32) === 32) result.push(i18n.t('FAILED TO TURN STP OFF'))
  if ((statusCode & 64) === 64) result.push(i18n.t('CALIBRATION IN PROGRESS'))
  if ((statusCode & 128) === 128) result.push(i18n.t('TEST IN PROGRESS'))
  if ((statusCode & 1024) === 1024) result.push(i18n.t('STP DISABLED'))

  return { statusDesc: result.join(',').toUpperCase(), alarmCount: result.length }
}
Vue.prototype.Maglink.GetLeakTestResultInfo = (resultCode) => {
  if (resultCode === 0) return { statusDesc: i18n.t('UNKNOWN').toUpperCase(), alarmCount: 0 }
  if (resultCode === 1) return { statusDesc: i18n.t('IN PROGRESS').toUpperCase(), alarmCount: 0 }
  if (resultCode === 2) return { statusDesc: i18n.t('TEST PASSED').toUpperCase(), alarmCount: 0 }
  if (resultCode === 3) return { statusDesc: i18n.t('LEAK DETECTED').toUpperCase(), alarmCount: 0 }
  if (resultCode === 4) return { statusDesc: i18n.t('ABORTED (STOPPED)').toUpperCase(), alarmCount: 0 }

  return { statusDesc: i18n.t('UNDEFINED').toUpperCase(), alarmCount: 0 }
}
Vue.prototype.Maglink.GetLeakTestStatusInfo = (statusCode) => {
  if (statusCode === 0) return { statusDesc: i18n.t('IDLE').toUpperCase(), alarmCount: 0 }
  if (statusCode === 1) return { statusDesc: i18n.t('INIT').toUpperCase(), alarmCount: 0 }
  if (statusCode === 2) return { statusDesc: i18n.t('MEASURE').toUpperCase(), alarmCount: 0 }
  if (statusCode === 3) return { statusDesc: i18n.t('SETTLE').toUpperCase(), alarmCount: 0 }
  if (statusCode === 4) return { statusDesc: i18n.t('PRESSURE ERR').toUpperCase(), alarmCount: 0 }
  if (statusCode === 5) return { statusDesc: i18n.t('DONE').toUpperCase(), alarmCount: 0 }

  return { statusDesc: i18n.t('UNDEFINED').toUpperCase(), alarmCount: 0 }
}

Vue.prototype.Maglink.TranslateOptionNames = (options) => {
  options.data.dateFormats.forEach(item => { item.desc = i18n.t(item.desc) })
  options.data.levelUnits.forEach(item => { item.desc = i18n.t(item.desc) })
  options.data.volumeUnits.forEach(item => { item.desc = i18n.t(item.desc) })
  options.data.temperatureUnits.forEach(item => { item.desc = i18n.t(item.desc) })
  options.data.probeTypes.forEach(item => { item.desc = i18n.t(item.desc) })
  options.data.productTypes.forEach(item => { item.desc = i18n.t(item.desc) })
  options.data.leakThresholds.forEach(item => { item.desc = i18n.t(item.desc) })
  return options
}

// format number based upon settings
// ----------------------------------------------------------------------------------------------------------------
Vue.prototype.Maglink.LevelFormat = (value, unit) => {
  return Vue.prototype.Maglink.RoundFormat(value, 2)
  /*
  if (unit === 0) return Vue.prototype.Maglink.RoundFormat(value, 0) // mm
  if (unit === 1) return Vue.prototype.Maglink.RoundFormat(value, 1) // cm
  if (unit === 2) return Vue.prototype.Maglink.RoundFormat(value, 2) // inches

  return Vue.prototype.Maglink.RoundFormat(value, 3)
  */
}
Vue.prototype.Maglink.TemperatureFormat = (value) => {
  return Vue.prototype.Maglink.RoundFormat(value, 1)
}
Vue.prototype.Maglink.VolumeFormat = (value, unit) => {
  return Vue.prototype.Maglink.RoundFormat(value, 2)

  /*
  if (unit === 0) return Vue.prototype.Maglink.RoundFormat(value, 1) // 0=litres
  if (unit === 1) return Vue.prototype.Maglink.RoundFormat(value, 1) // 1=gallons

  return Vue.prototype.Maglink.RoundFormat(value, 3)
  */
}
Vue.prototype.Maglink.DensityFormat = (value) => {
  return Vue.prototype.Maglink.RoundFormat(value, 1)
}
Vue.prototype.Maglink.LeakageFormat = (value, unit) => {
  return Vue.prototype.Maglink.RoundFormat(value, 3)
}
Vue.prototype.Maglink.PercentageFormat = (value) => {
  return Vue.prototype.Maglink.RoundFormat(value * 100.0, 1)
}
Vue.prototype.Maglink.PressureFormat = (value) => {
  return Vue.prototype.Maglink.RoundFormat(value, 2)
}
// ----------------------------------------------------------------------------------------------------------------

// generic functions
// ----------------------------------------------------------------------------------------------------------------
Vue.prototype.Maglink.IsDate = (dateString, inputFormat) => {
  let s = dateString.split('-')
  let dd = 0
  let mm = 0
  let yy = 0

  inputFormat = inputFormat.toLowerCase()
  if (inputFormat === 'dd-mm-yyyy') {
    dd = s[0] * 1 // to number
    mm = s[1] - 1
    yy = s[2] * 1 // to number
  } else if (inputFormat === 'mm-dd-yyyy') {
    dd = s[1] * 1 // to number
    mm = s[0] - 1
    yy = s[2] * 1 // to number
  } else if (inputFormat === 'yyyy-mm-dd') {
    dd = s[2] * 1 // to number
    mm = s[1] - 1
    yy = s[0] * 1 // to number
  }

  let stdDate = new Date(+yy, mm, +dd)
  let objType = Object.prototype.toString.call(stdDate)

  if (objType === '[object Date]') return (stdDate.getDate() === dd && stdDate.getMonth() === mm)

  return false
}

Vue.prototype.Maglink.RoundFormat = (value, decimals) => {
  if (value === null) {
    return '-'
  }
  return parseFloat(Number(Math.round(value + 'e' + decimals) + 'e-' + decimals).toFixed(decimals))
}

Vue.prototype.Maglink.IdFormat = (value) => {
  return value.replace(/[/\\ ]/g, '-')
}

// ----------------------------------------------------------------------------------------------------------------

Vue.prototype.Maglink.Timezones = [
  'GMT-11 (Pago Pago)',
  'GMT-10 (Honolulu)',
  'GMT-10 (Adak)',
  'GMT-9 (Gambier)',
  'GMT-9 (Anchorage)',
  'GMT-8 (Pitcairn)',
  'GMT-8 (Los Angeles)',
  'GMT-7 (Phoenix)',
  'GMT-7 (Denver)',
  'GMT-6 (Regina)',
  'GMT-6 (Chicago)',
  'GMT-5 (Jamaica)',
  'GMT-5 (New York)',
  'GMT-4 (Caracas)',
  'GMT-4 (Santiago)',
  'GMT-3:30 (St Johns)',
  'GMT-3 (Sao Paulo)',
  'GMT-3 (Miquelon)',
  'GMT-2 (South Georgia)',
  'GMT-1 (Cape Verde)',
  'GMT-1 (Azores)',
  'GMT (ETC)',
  'GMT (London)',
  'GMT+1 (Tunis)',
  'GMT+1 (Paris)',
  'GMT+2 (Cairo)',
  'GMT+2 (Athens)',
  'GMT+3 (Moscow)',
  'GMT+3:30 (Tehran)',
  'GMT+4 (Dubai)',
  'GMT+4:30 (Kabul)',
  'GMT+5 (Karachi)',
  'GMT+5:30 (Kolkata)',
  'GMT+5:45 (Kathmandu)',
  'GMT+6 (Dhaka)',
  'GMT+6:30 (Yangon)',
  'GMT+7 (Bangkok)',
  'GMT+8 (Hong Kong)',
  'GMT+8:45 (Eucla)',
  'GMT+9 (Tokyo)',
  'GMT+9:30 (Darwin)',
  'GMT+9:30 (Adelaide)',
  'GMT+10 (Brisbane)',
  'GMT+10 (Sydney)',
  'GMT+10:30 (Lord Howe)',
  'GMT+11 (Noumea)',
  'GMT+11 (Norfolk)',
  'GMT+12 (Kamchatka)',
  'GMT+12 (Auckland)',
  'GMT+12:45 (Chatham)',
  'GMT+13 (Enderbury)',
  'GMT+14 (Kiritimati)'
]

Vue.prototype.Maglink.TimezoneHours = [
  -11.0, // (Pago Pago)',
  -10.0, // (Honolulu)',
  -10.0, // (Adak)',
  -9.0, // (Gambier)',
  -9.0, // (Anchorage)',
  -8.0, // (Pitcairn)',
  -8.0, // (Los Angeles)',
  -7.0, // (Phoenix)',
  -7.0, // (Denver)',
  -6.0, // (Regina)',
  -6.0, // (Chicago)',
  -5.0, // (Jamaica)',
  -5.0, // (New York)',
  -4.0, // (Caracas)',
  -4.0, // (Santiago)',
  -3.5, // (St Johns)',
  -3.0, // (Sao Paulo)',
  -3.0, // (Miquelon)',
  -2.0, // (South Georgia)',
  -1.0, // (Cape Verde)',
  -1.0, // (Azores)',
  0.0, // (ETC)',
  0.0, // (London)',
  1.0, // (Tunis)',
  1.0, // (Paris)',
  2.0, // (Cairo)',
  2.0, // (Athens)',
  3.0, // (Moscow)',
  3.5, // (Tehran)',
  4.0, // (Dubai)',
  4.5, // (Kabul)',
  5.0, // (Karachi)',
  5.5, // (Kolkata)',
  5.75, // (Kathmandu)',
  6.0, // (Dhaka)',
  6.5, // (Yangon)',
  7.0, // (Bangkok)',
  8.0, // (Hong Kong)',
  8.75, // (Eucla)',
  9.0, // (Tokyo)',
  9.5, // (Darwin)',
  9.5, // (Adelaide)',
  10.0, // (Brisbane)',
  10.0, // (Sydney)',
  10.5, // (Lord Howe)',
  11.0, // (Noumea)',
  11.0, // (Norfolk)',
  12.0, // (Kamchatka)',
  12.0, // (Auckland)',
  12.75, // (Chatham)',
  13.0, // (Enderbury)',
  14.0 // (Kiritimati)'
]

Vue.prototype.Maglink.TimezoneCodes = [
  'Pacific/Pago_Pago',
  'Pacific/Honolulu',
  'America/Adak',
  'Pacific/Gambier',
  'America/Anchorage',
  'Pacific/Pitcairn',
  'America/Los_Angeles',
  'America/Phoenix',
  'America/Denver',
  'America/Regina',
  'America/Chicago',
  'America/Jamaica',
  'America/New_York',
  'America/Caracas',
  'America/Santiago',
  'America/St_Johns',
  'America/Sao_Paulo',
  'America/Miquelon',
  'Atlantic/South_Georgia',
  'Atlantic/Cape_Verde',
  'Atlantic/Azores',
  'Etc/GMT',
  'Europe/London',
  'Africa/Tunis',
  'Europe/Paris',
  'Africa/Cairo',
  'Europe/Athens',
  'Europe/Moscow',
  'Asia/Tehran',
  'Asia/Dubai',
  'Asia/Kabul',
  'Asia/Karachi',
  'Asia/Kolkata',
  'Asia/Kathmandu',
  'Asia/Dhaka',
  'Asia/Yangon',
  'Asia/Bangkok',
  'Asia/Hong_Kong',
  'Australia/Eucla',
  'Asia/Tokyo',
  'Australia/Darwin',
  'Australia/Adelaide',
  'Australia/Brisbane',
  'Australia/Sydney',
  'Australia/Lord_Howe',
  'Pacific/Noumea',
  'Pacific/Norfolk',
  'Asia/Kamchatka',
  'Pacific/Auckland',
  'Pacific/Chatham',
  'Pacific/Enderbury',
  'Pacific/Kiritimati'
]

Vue.prototype.Maglink.Timezone = (timezoneCode) => {
  var tmIndex = Vue.prototype.Maglink.TimezoneCodes.indexOf(timezoneCode)
  if (tmIndex === -1) {
    tmIndex = Vue.prototype.Maglink.TimezoneCodes.indexOf('Etc/GMT')
  }

  return {
    name: Vue.prototype.Maglink.Timezones[tmIndex],
    hour: Vue.prototype.Maglink.TimezoneHours[tmIndex]
  }
}

Vue.prototype.Maglink.TimezoneCode = (timezoneName) => {
  var tmIndex = Vue.prototype.Maglink.Timezones.indexOf(timezoneName)
  if (tmIndex === -1) {
    tmIndex = Vue.prototype.Maglink.TimezoneCodes.indexOf('Etc/GMT')
  }

  return Vue.prototype.Maglink.TimezoneCodes[tmIndex]
}

// ----------------------------------------------------------------------------------------------------------------

Vue.prototype.Maglink.GetDownloadLinkCSV = (fileContent, filename) => {
  const url = window.URL.createObjectURL(new Blob(['\ufeff', fileContent], { type: 'application/vnd.ms-excel' }))
  const link = document.createElement('a')
  // <meta http-equiv="Content-Type" content='text/html; charset=UTF-8'>
  link.href = url
  link.setAttribute('download', filename)

  return link
}

Vue.prototype.Maglink.GetDownloadLinkText = (fileContent, filename) => {
  const url = window.URL.createObjectURL(new Blob(['\ufeff', fileContent], { type: 'application/octet-stream' }))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)

  return link
}

Vue.prototype.Maglink.GetDownloadLinkBinary = (fileContent, filename) => {
  const blob = new Blob([fileContent], { type: 'application/octet-stream' })
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = filename

  return link
}

Vue.prototype.Maglink.FileWebDownload = (filename) => {
  return axios({
    url: '/files/' + filename,
    method: 'GET',
    responseType: 'blob'
  })
}

Vue.prototype.Maglink.DetectedSerialName = (item) => {
  var text = ''
  if (item.device === 80 && item.serial !== '0') {
    text = item.serial
    text = Vue.prototype.Maglink.PadRight(text, text.length > 5 ? 10 : 5)
    if (text.length === 10 && text.substring(0, 4) === '4220') {
      text += ': ' + i18n.t('VSmart') + ' ' + parseInt(text.substring(7, 8), 10) + ' ' + i18n.t('position') + ' ' + parseInt(text.substring(8, 10), 10)
    } else {
      var probeTypes = Vue.prototype.Maglink.ProbeTypesBasic()
      probeTypes = probeTypes.concat(Vue.prototype.Maglink.ProbeTypesPlus())
      for (var i = 0; i < probeTypes.length; i++) {
        if (probeTypes[i].code === item.model) {
          text += ': ' + probeTypes[i].desc
          break
        }
      }
    }
  }
  if (item.device === 83 && item.serial !== '0') {
    text = item.serial + ': ' + item.modelName + ' ' + item.description
  }
  return text
}

Vue.prototype.Maglink.isDMPProbe = (probeType) => {
  return (probeType === 6 || probeType === 13 || probeType === 17 || probeType === 20)
}

Vue.prototype.Maglink.isEPAProbe = (probeType) => {
  return (probeType === 6 || probeType === 13 || probeType === 12 || probeType === 18)
}

Vue.prototype.Maglink.isEPAProbeExtended = (probeType, probeCapability) => {
  if (probeType === 6 || probeType === 13) { // DMP-485 or 1-Wire
    return probeCapability !== 0
  } else if (probeType === 12 || probeType === 18) {
    return true
  } else {
    return false
  }
}

Vue.prototype.Maglink.ProbeTypesBasic = () => {
  return [
    { index: 0, code: 6, desc: i18n.t('DMP-485'), isAnalog: false, isRadar: false, isDensAllowed: true, isWaterAllowed: true, isDensAefAllowed: true, image: './img/tank/probe_dmp.png', imageWaterFloat: './img/tank/probe_water_pg.png', imageDensityFloat: './img/tank/probe_dens_pg.png', imageAefFloat: './img/tank/probe_aef_pg.png' },
    // { index: 4, code: 0, desc: i18n.t('DMP-IS-RF'), isAnalog: false, isRadar: false, isDensAllowed: true, isWaterAllowed: true, isDensAefAllowed: true, image: './img/tank/probe_dmp_rf.png', imageWaterFloat: './img/tank/probe_water_pg.png', imageDensityFloat: './img/tank/probe_dens_pg.png', imageAefFloat: './img/tank/probe_aef_pg.png' },
    { index: 2, code: 17, desc: i18n.t('DMP Flex'), isAnalog: false, isRadar: false, isDensAllowed: false, isWaterAllowed: true, isDensAefAllowed: true, image: './img/tank/probe_dmp_flex.png', imageWaterFloat: './img/tank/probe_water_flex.png', imageDensityFloat: './img/tank/probe_dens_pg.png', imageAefFloat: './img/tank/probe_aef_flex.png' },
    { index: 5, code: 0, desc: i18n.t('XMT-SI-485'), isAnalog: false, isRadar: false, isDensAllowed: false, isWaterAllowed: true, isDensAefAllowed: false, image: './img/tank/probe_xmt.png', imageWaterFloat: './img/tank/probe_water_pg.png', imageDensityFloat: './img/tank/probe_dens_empty.png', imageAefFloat: './img/tank/probe_aef_pg.png' },
    { index: 6, code: 2, desc: i18n.t('XMT-SI-RF'), isAnalog: false, isRadar: false, isDensAllowed: false, isWaterAllowed: true, isDensAefAllowed: false, image: './img/tank/probe_xmt_rf.png', imageWaterFloat: './img/tank/probe_water_pg.png', imageDensityFloat: './img/tank/probe_dens_empty.png', imageAefFloat: './img/tank/probe_aef_pg.png' },
    { index: 7, code: 19, desc: i18n.t('XMT-Exd'), isAnalog: false, isRadar: false, isDensAllowed: false, isWaterAllowed: true, isDensAefAllowed: false, image: './img/tank/probe_exd.png', imageWaterFloat: './img/tank/probe_water_pg.png', imageDensityFloat: './img/tank/probe_dens_empty.png', imageAefFloat: './img/tank/probe_aef_pg.png' },
    { index: 14, code: 16, desc: i18n.t('Radar LR120'), isAnalog: false, isRadar: true, isDensAllowed: false, isWaterAllowed: false, isDensAefAllowed: false, image: './img/tank/probe_radar.png', imageWaterFloat: './img/tank/probe_water_empty.png', imageDensityFloat: './img/tank/probe_dens_empty.png', imageAefFloat: './img/tank/probe_water_empty.png' }
  ]
}

Vue.prototype.Maglink.ProbeTypesPlus = () => {
  return [
    { index: 1, code: 13, desc: i18n.t('DMP 1-wire'), isAnalog: false, isRadar: false, isDensAllowed: true, isWaterAllowed: true, isDensAefAllowed: true, image: './img/tank/probe_dmp.png', imageWaterFloat: './img/tank/probe_water_pg.png', imageDensityFloat: './img/tank/probe_dens_pg.png', imageAefFloat: './img/tank/probe_aef_pg.png' },
    { index: 3, code: 20, desc: i18n.t('DMP Flex 1-wire'), isAnalog: false, isRadar: false, isDensAllowed: false, isWaterAllowed: true, isDensAefAllowed: true, image: './img/tank/probe_dmp_flex.png', imageWaterFloat: './img/tank/probe_water_flex.png', imageDensityFloat: './img/tank/probe_dens_pg.png', imageAefFloat: './img/tank/probe_aef_flex.png' },
    { index: 8, code: 12, desc: i18n.t('OPW 924B'), isAnalog: false, isRadar: false, isDensAllowed: true, isWaterAllowed: true, isDensAefAllowed: false, image: './img/tank/probe_924b.png', imageWaterFloat: './img/tank/probe_water_opw.png', imageDensityFloat: './img/tank/probe_dens_opw.png', imageAefFloat: './img/tank/probe_aef_opw.png' },
    { index: 9, code: 18, desc: i18n.t('OPW 924A'), isAnalog: false, isRadar: false, isDensAllowed: true, isWaterAllowed: true, isDensAefAllowed: false, image: './img/tank/probe_924a.png', imageWaterFloat: './img/tank/probe_water_opw.png', imageDensityFloat: './img/tank/probe_dens_opw.png', imageAefFloat: './img/tank/probe_aef_opw.png' },
    { index: 10, code: 14, desc: i18n.t('VSmart Analog'), isAnalog: true, analogType: 0, isRadar: false, isDensAllowed: false, isWaterAllowed: true, isDensAefAllowed: false, image: './img/tank/probe_ametek.png', imageWaterFloat: './img/tank/probe_water_ametek.png', imageDensityFloat: './img/tank/probe_dens_empty.png', imageAefFloat: './img/tank/probe_water_empty.png' },
    { index: 11, code: 14, desc: i18n.t('VSmart Ametek'), isAnalog: true, analogType: 76, isRadar: false, isDensAllowed: false, isWaterAllowed: true, isDensAefAllowed: false, image: './img/tank/probe_ametek.png', imageWaterFloat: './img/tank/probe_water_ametek.png', imageDensityFloat: './img/tank/probe_dens_empty.png', imageAefFloat: './img/tank/probe_water_empty.png' },
    { index: 12, code: 14, desc: i18n.t('VSmart Ametek'), isAnalog: true, analogType: 83, isRadar: false, isDensAllowed: false, isWaterAllowed: true, isDensAefAllowed: false, image: './img/tank/probe_ametek.png', imageWaterFloat: './img/tank/probe_water_ametek.png', imageDensityFloat: './img/tank/probe_dens_empty.png', imageAefFloat: './img/tank/probe_water_empty.png' },
    { index: 13, code: 14, desc: i18n.t('VSmart EECO'), isAnalog: true, analogType: 69, isRadar: false, isDensAllowed: false, isWaterAllowed: true, isDensAefAllowed: false, image: './img/tank/probe_eeco.png', imageWaterFloat: './img/tank/probe_water_eeco.png', imageDensityFloat: './img/tank/probe_dens_empty.png', imageAefFloat: './img/tank/probe_water_empty.png' }
  ]
}

Vue.prototype.Maglink.SensorTypesBasic = () => {
  return [
    { index: 0, code: 0, desc: i18n.t('On/Off Sensor'), disabled: false },
    { index: 1, code: 1, desc: i18n.t('Discriminating Sensor'), disabled: false },
    { index: 2, code: 2, desc: i18n.t('Wireless (2 floats)'), disabled: false },
    { index: 3, code: 3, desc: i18n.t('Wireless (1 float)'), disabled: false }
  ]
}

Vue.prototype.Maglink.SensorTypesPlus = () => {
  return [
    { index: 4, code: 4, desc: i18n.t('Discriminating Dispenser Sump Sensor'), disabled: true },
    { index: 5, code: 5, desc: i18n.t('Discriminating STP Sump Sensor'), disabled: true },
    { index: 6, code: 6, desc: i18n.t('Discriminating Interstitial Sensor (Optical)'), disabled: true },
    { index: 7, code: 7, desc: i18n.t('6ft.(183 cm) HC Liquid Sensor with water indicator'), disabled: true },
    { index: 8, code: 8, desc: i18n.t('15ft.(457 cm) HC Liquid Sensor with water indicator'), disabled: true },
    { index: 9, code: 9, desc: i18n.t('20ft.(610 cm) HC Liquid Sensor with water indicator'), disabled: true },
    { index: 10, code: 10, desc: i18n.t('Interstitial HC Liquid with water indicator'), disabled: true },
    { index: 11, code: 11, desc: i18n.t('Interstitial Sensor-Float Switch(Small Plastic)'), disabled: true },
    { index: 12, code: 12, desc: i18n.t('Sump Sensor-Float Switch(Large Plastic)'), disabled: true },
    { index: 13, code: 13, desc: i18n.t('Liquid Only Float Sensor (Brass)'), disabled: true },
    { index: 14, code: 14, desc: i18n.t('Dual Float Non-Discriminating Dispenser Sump Sensor'), disabled: true },
    { index: 15, code: 15, desc: i18n.t('Dual Float Non-Discriminating STP Sump Sensor'), disabled: true },
    { index: 16, code: 16, desc: i18n.t('Dual Float Brine Sensor for Containment Sump'), disabled: true },
    { index: 17, code: 17, desc: i18n.t('Dual Float Brine Sensor for Fiberglass Tanks'), disabled: true },
    { index: 18, code: 18, desc: i18n.t('Hydrocarbon Vapor Sensor'), disabled: true },
    { index: 19, code: 19, desc: i18n.t('Generic Float Sensor NO'), disabled: true },
    { index: 20, code: 20, desc: i18n.t('Generic Float Sensor NC'), disabled: true }
  ]
}

Vue.prototype.Maglink.isApiDegree = (value) => {
  return value < 315 && value > 0.1
}
Vue.prototype.Maglink.toApiDegree = (value) => {
  if (Vue.prototype.Maglink.isApiDegree(value) || value < 0.1) {
    return value
  }
  return (141500 / value) - 131.5
}
Vue.prototype.Maglink.fromApiDegree = (value) => {
  if (Vue.prototype.Maglink.isApiDegree(value)) {
    return 141500 / (value + 131.5)
  }
  return value
}

Vue.prototype.Maglink.checkCsldEnabled = (feature) => {
  return ((feature & 1024 * 1024) === 1024 * 1024)
}

const totalCsldTanks = Vue.observable({ value: -1 })

Object.defineProperty(Vue.prototype, '$totalCsldTanks', {
  get () {
    return totalCsldTanks.value
  },

  set (value) {
    totalCsldTanks.value = value
  }
})

// TODO replace with products API when ready
Vue.prototype.Maglink.Products = [
  { code: 0, baseDensity: 1000.0 },
  { code: 1, baseDensity: 815.0 },
  { code: 2, baseDensity: 840.0 },
  { code: 3, baseDensity: 840.0 },
  { code: 4, baseDensity: 840.0 },
  { code: 5, baseDensity: 835.0 },
  { code: 6, baseDensity: 880.0 },
  { code: 7, baseDensity: 455.0 },
  { code: 8, baseDensity: 540.0 },
  { code: 9, baseDensity: 780.0 },
  { code: 10, baseDensity: 735.0 },
  { code: 11, baseDensity: 745.0 },
  { code: 12, baseDensity: 780.0 },
  { code: 13, baseDensity: 740.0 },
  { code: 14, baseDensity: 740.0 },
  { code: 15, baseDensity: 740.0 },
  { code: 16, baseDensity: 745.0 },
  { code: 17, baseDensity: 830.0 },
  { code: 18, baseDensity: 820.0 },
  { code: 19, baseDensity: 1087.0 },
  { code: 20, baseDensity: 1087.0 },
  { code: 21, baseDensity: 1000.0 }
]
// ----------------------------------------------------------------------------------------------------------------
Vue.prototype.Maglink.generateSerialize = (serialize) => {
  const dt = new Date()
  if (serialize === undefined || serialize === null || serialize === 0) {
    serialize = parseInt(Vue.prototype.Maglink.GetCustomDate(dt, 'yyyymmdd').substring(2)) * 100
  }
  let newSerialize = parseInt(Vue.prototype.Maglink.GetCustomDate(dt, 'yyyymmdd').substring(2)) * 100

  if (Math.floor(serialize / 100) !== newSerialize / 100) {
    return newSerialize + 1
  }

  let progress = serialize % 100
  return newSerialize + progress + 1
}
